import { isListEmpty, isObjectEmpty, isStringEmpty } from "./objectUtils";

/**
 * Finds the supplier mapping for a given supplierId within a variant's supplierMappings array.
 * @param {Object} variant - The variant object with supplierMappings[]
 * @param {string} supplierId - The coveredEntityId of the pharmacy
 * @returns {Object|null}
 */
export const findSupplierMapping = (variant, supplierId) => {
    if (isListEmpty(variant?.supplierMappings) || isStringEmpty(supplierId)) return null;
    return variant.supplierMappings.find(m => m.supplierId === supplierId) || null;
};

export const MISSING_SUPPLIER_MAPPING = 'MISSING_SUPPLIER_MAPPING';

/**
 * The supplier mapping a prescription request needs.
 *
 * A request without the pharmacy's med id cannot be filled, so this throws rather than returning null.
 * The error is coded and carries the ids so the caller can alert tech - the detail is never meant for a
 * patient, who cannot act on a mapping gap.
 * @param {Object} variant - the variant being requested
 * @param {string} supplierId - the subscription's pharmacyId
 * @returns {Object}
 */
export const getRequiredSupplierMapping = (variant, supplierId) => {
    const supplierMapping = findSupplierMapping(variant, supplierId);
    if (isObjectEmpty(supplierMapping) || isStringEmpty(supplierMapping.refId)) {
        const error = new Error(`Variant ${variant?.id ?? 'unknown'} has no supplier mapping with a med id for supplier ${supplierId ?? 'unknown'}`);
        error.code = MISSING_SUPPLIER_MAPPING;
        error.details = {
            variantId: variant?.id ?? null,
            variantName: variant?.name ?? null,
            productId: variant?.productId ?? null,
            supplierId: supplierId ?? null,
        };
        throw error;
    }

    return supplierMapping;
};
